import React, { useState, useEffect } from 'react';
import './diamondGrid.css';
import { IoArrowForwardCircleOutline } from "react-icons/io5";
import { itemsDiamonds } from '../../../../json/sections/Home/ItemsDiamonds';
import { Link } from 'react-router-dom';

export default function DiamondGrid() {
    const [pattern, setPattern] = useState([3, 2]);

    useEffect(() => {
        const update = () =>
            setPattern(window.innerWidth <= 768 ? [2, 1] : [3, 2]);
        update();
        window.addEventListener('resize', update);
        return () => window.removeEventListener('resize', update);
    }, []);

    const rows = [];
    let idx = 0, pi = 0;
    while (idx < itemsDiamonds.length) {
        const count = pattern[pi % pattern.length];
        const slice = itemsDiamonds.slice(idx, idx + count);
        idx += slice.length;

        let full = slice.slice();
        if (slice.length < count) {
            if (count % 2 === 1) {
                full.splice(1, 0, ...Array(count - slice.length).fill(null));
            } else {
                full.push(...Array(count - slice.length).fill(null));
            }
        }

        rows.push({ itemsDiamonds: full, count });
        pi++;
    }

    return (
        <div className="diamond-grid">
            {rows.map(({ itemsDiamonds: row, count }, ri) => (
                <div key={ri} className={`diamond-row count-${count}`}>
                    {row.map((item, i) =>
                        item ? (
                            <div
                                key={i}
                                className="diamond-item"
                                style={{ backgroundImage: `url(${item.image})` }}
                            >
                                <div className="diamond-content">
                                    <Link to={`/services/${item.link}`}>{item.title}
                                        <IoArrowForwardCircleOutline className="arrow" />
                                    </Link>

                                </div>
                            </div>
                        ) : (
                            <>
                                <div
                                    key={i}
                                    className="diamond-placeholder"
                                />
                                <div
                                    key={i}
                                    className="diamond-item-special"
                                    style={{
                                        backgroundImage: `url('/assets/imgs/home/diamond/fondo.png')`,
                                        backgroundPosition: 'center',
                                        backgroundSize: 'contain',
                                        backgroundRepeat: 'no-repeat',
                                        width: '100%',
                                        height: '500px',
                                        position: 'absolute'
                                    }}
                                />
                            </>

                        )
                    )}
                </div>
            ))}
        </div>
    );
}